import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {DataTableBody as RmwcDataTableBody} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

const StyledRmwcDataTableBody = styled(RmwcDataTableBody)``

const DataTableBody = ({children, ...otherProps}) => <StyledRmwcDataTableBody {...otherProps}>{children}</StyledRmwcDataTableBody>

DataTableBody.propTypes = {
  children: PropTypes.any
}

export {DataTableBody}
